// tslint:disable:jsx-no-lambda
// tslint:disable:jsx-no-bind
// tslint:disable:jsx-no-string-ref
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { WithAriticleEdit } from '../../components/HOC/EditArticleHOC/EditArticleHOC';
import { WithMediaUpload } from '../../components/HOC/AliyunMediaUpload';
import Editor from '../../components/Editor';
import ArticleEdit from '../../components/ArticleEdit';
import * as classnames from 'classnames';
import moment from 'moment';

import './test.scss';
@WithMediaUpload(inject('store'))
@WithAriticleEdit(inject('store'))
export default class Test extends React.Component<any, any> {
    public checkSaveDraftTimer: any;
    public showPreview = () => {
        this.props.showPreview();
    }
    public checkSaveDraft = (bool) => {
        this.props.checkSaveDraft(bool);
    }
    public showTimeing = () => {
        this.props.showTimeing();
    }
    public checkCreateArticel = () => {
        this.props.checkCreateArticel(() => {
            clearInterval(this.checkSaveDraftTimer);
        });
    }
    public closeCrop = (e) => {
        this.props.closeCrop(e);
    }
    public timeOnchange = () => {
        this.props.timeOnchange();
    }
    public getPublicTime = (e) => {
        this.props.getPublicTime(e);
    }
    public componentDidMount() {
        console.log(this.props);
        this.checkSaveDraftTimer = setInterval(() => {
            this.props.checkSaveDraft();
        }, 5000);
    }
    public componentWillUnmount() {
        clearInterval(this.checkSaveDraftTimer);
    }
    public render() {
        console.log(this.props);
        const { errorStatus, errorContent, previewBoxHasHide, cropImg, articleTitle, avatar, userName, previewContent, timingPublicBoxHasHide, getChildRefs } = this.props;
        return (
            <div className="testbox">
                <div className="createArticleHeader" style={!errorStatus ? { zIndex: 1 } : null} >
                    <div className="headerBox">
                        <div className="createArticleLogoNav">
                            <div className="createArticleLogo">
                                <a href="/"><img src={require('../../assets/images/commonImg/logoWhiteBg.png')} alt="" /></a>
                            </div>
                            <div className="createArticleNav">
                                <p><span>写文章</span> > <span>编辑中</span></p>
                            </div>
                        </div>
                        <div className="createCheckBtn">
                            <div className="createCurrentBtn">
                                <span onClick={() => this.showPreview()}>预览手机版</span>
                                <span onClick={() => this.checkSaveDraft(true)}>保存草稿</span>
                                <span onClick={() => this.showTimeing()}>定时发布</span>
                            </div>
                            <div className="createArticleBtn">
                                <span onClick={() => this.checkCreateArticel()}>发布文章</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ArticleEdit {...this.props} />
                <div className={classnames('timingPublicBox', { hide: timingPublicBoxHasHide })}>
                    <div className="selectTimeBox">
                        <div className="timingBoxHeader">
                            <h4>定时发布</h4>
                            <span className="closeBtn" onClick={(e) => this.closeCrop(e)}>
                                <img src={require('../../assets/images/commonImg/closeBtn.png')} alt="" />
                            </span>
                        </div>
                        <div className="timingConBox">
                            <span>请选择发布时间</span>
                            <div className="selectBox">
                                <select name="" id="timeDay" ref={(timeDay) => getChildRefs({ name: 'timeDay', value: timeDay })} onChange={(e) => this.timeOnchange()}>
                                    {
                                        this.props.timeDay && this.props.timeDay.map((item, idx) => {
                                            return <option value={item} key={idx}>{item}</option>;
                                        })
                                    }
                                    {/* <option value="today">今天</option>
                                        <option value="tomorrow">明天</option> */}
                                </select>
                                <select name="" id="timeHour" ref={(timeHour) => getChildRefs({ name: 'timeHour', value: timeHour })} onChange={(e) => this.timeOnchange()}>
                                    {
                                        this.props.timeHour && this.props.timeHour.map((item, idx) => {
                                            return <option key={idx} value={item}>{item}</option>;
                                        })
                                    }
                                </select>
                                时
                                    <select name="" id="timeMinute" ref={(timeMinute) => getChildRefs({ name: 'timeMinute', value: timeMinute })} onChange={(e) => this.timeOnchange()}>
                                    {
                                        this.props.timeMinute && this.props.timeMinute.map((item, idx) => {
                                            return <option key={idx} value={item}>{item}</option>;
                                        })
                                    }
                                </select>
                                分
                                </div>
                        </div>
                        <p>只能选择2-24小时范围内的时间</p>
                        <div className="timingBoxBottom">
                            <span onClick={(e) => this.closeCrop(e)}>取消</span><span onClick={(e) => this.getPublicTime(e)}>确定</span>
                        </div>
                    </div>
                    <div className="timingBoxScreen" onClick={(e) => this.closeCrop(e)}></div>
                </div>
                <div className={classnames('previewBox', { hide: previewBoxHasHide })} onClick={(e) => this.closeCrop(e)}>

                    <div className="phoneBox">
                        <span className="previewCloseBtn">
                            <img src={require('../../assets/images/commonImg/whiteCloseBtn.png')} alt="" />
                        </span>

                        <div className="phoneBang"></div>
                        <div className="phoneConBox">
                            <div className="phoneBanner">
                                <img src={cropImg} alt="" />
                            </div>
                            <div className="articleBox">
                                <h3 className="phoneTitle">{articleTitle}</h3>
                                <div className="articleTop">
                                    <div className="leftUserInfo">
                                        <div className="authorImg">
                                            {avatar && <img src={avatar} alt={userName} />}
                                        </div>
                                        <div className="nameTime">
                                            <div className="authorName">{userName || '未知'}</div>
                                            <div className="phonePublicTime">
                                                {moment().format('MM月DD日')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rightFollow">
                                        <span>+关注</span>
                                    </div>
                                </div>
                                <div className="phoneArticleIco"></div>
                                <div className="phoneArticleCon" dangerouslySetInnerHTML={{ __html: previewContent }}></div>
                            </div>
                        </div>
                        <div className="phoneMenu"></div>
                    </div>
                    <div className="previewBoxScreen" onClick={(e) => this.closeCrop(e)}></div>
                </div>
                <div className={classnames('bigScreen', { hide: errorStatus })}>
                    <div className="errInfo">{errorContent}</div>
                </div>
                <div className="itemEditorCon" ref={(itemEditorCon) => getChildRefs({ name: 'itemEditorCon', value: itemEditorCon })}></div>
            </div>
        );
    }
}
